import { ThumbNail } from '../../components/uiParts/ThumbNails/ThumbNailsMini/ThumbNailsMini';
import { useContentfulFetchers } from '../../context/ContentfulContext';
import { useAsyncContentfulQuery } from './useAsyncContentfulQuery';

export function useProjectsQuery() {
  const { fetchProjects } = useContentfulFetchers();
  return useAsyncContentfulQuery<ThumbNail[]>(() => fetchProjects(), [fetchProjects]);
}
